export function getNextAvailableTab(user, checkPermissionByRoles) {
    const tabMapping = {
      viewDashboard: "dashboard",
      schedule: "appointments",
      userManagement: "users",
      providerManagement: "providers",
      sessionHistory: "session-history",
      accessCodes: "businesses",
      teamMembersManagement: "team-member",
      roleManagement: "role_management",
    };
  
    for (const tab in tabMapping) {
      if (checkPermissionByRoles(user, tab)) {
        return tabMapping[tab]; 
      }
    }
  
    return null;
  }
